import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PageCTA() {
  return <section className="py-24 bg-[#0a0a0a] relative border-t border-white/[0.05]" data-id="element-154">
      <div className="container mx-auto px-6 md:px-12 relative z-10 max-w-4xl" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="card-premium !rounded-3xl p-10 md:p-16 text-center" data-id="element-156">
          <h2 className="text-3xl md:text-4xl font-medium text-white mb-4 tracking-tight" data-id="element-157">
            Es el momento de dar el paso
          </h2>
          <p className="text-gray-400 text-base md:text-lg mb-10 max-w-xl mx-auto leading-relaxed" data-id="element-158">
            Tu competencia ya está online. Es hora de que tú también lo estés
            con una presencia que realmente funcione.
          </p>

          <div className="flex flex-col items-center justify-center" data-id="element-159">
            <Link to="/checkout" className="inline-flex justify-center items-center gap-2 bg-brand-emerald text-[#0a0a0a] px-8 py-3.5 rounded-xl font-medium text-[15px] hover:bg-brand-emeraldLight transition-colors group mb-4" data-id="element-160">
              Solicitar mi proyecto
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-161" />
            </Link>
            <p className="text-[12px] text-gray-500" data-id="element-162">
              Solo 50€ para empezar · Sin compromiso
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}